import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FindRoiParams, PageParams } from "../../utils/datatype";



const state = localStorage.getItem('roiQuery');

// * roi 查询数据 Query初始状态
// * requestType: 请求类型 - query
// * params: 请求参数 - params
// * platform: 请求数据所属平台 - platform
const initialState: {
    users: {
        [key: string] : {
            googleparams: FindRoiParams;
            platform: string;
            facebookparams: FindRoiParams;
            bingparams: FindRoiParams;
            snapparams: FindRoiParams & PageParams;
        };
    },
    enableAutoQuery: boolean;
    refetch: string;
} = state ? JSON.parse(state) : {
    enableAutoQuery: false,
    refetch: '',
    users: {}
};
/**
 * platform: "",
    params: {
        labelUrl: "",
        channel: "",
        country: "",
        date: "",
        endDate: "",
        currencyCode: "",
        uid: "",
        dataType: ""
    }
 */

/**
 * `roiQuerySlice` 是一个 Redux slice，它包含了 roi 查询的状态和一些 reducer 函数。
 * 
 * `setRoiParams` 是一个 reducer，它接收一个包含 `platform` 、 `requestType` 和 `params` 的对象，
 * 并将这些值设置到状态中。
 * 
 * `clearRoiParams` 是一个 reducer，它清除状态中的 `requestType` 和 `params`。
 */
export const roiQuerySlice = createSlice({
    name: "roi",
    initialState: initialState,
    reducers: {
        setUserQuery: (state, action: PayloadAction<{ atn: string, value: { params: FindRoiParams & PageParams, platform: string } }>) => {
            const { atn, value } = action.payload;
            if(state.users[atn] === undefined){
                state.users[atn] = {
                } as any;
            }
            state.users[atn].platform = value.platform;
            switch(value.platform){
                case 'bing':
                    state.users[atn].bingparams = value.params;
                    break;
                case 'facebook':
                    state.users[atn].facebookparams = value.params;
                    break;
                case 'snap':
                    state.users[atn].snapparams = value.params;
                    break;
                default:
                    state.users[atn].googleparams = value.params;
                    break;
            }
            if(value.params && (!value.params.channel || !value.params.labelUrl)){
                state.enableAutoQuery = false;
            }
            localStorage.setItem('roiQuery', JSON.stringify(state));
        },
        switchAutoQuery: (state, action: PayloadAction<boolean>) => {
            state.enableAutoQuery = action.payload;
        },
        setRefetch: (state, action: PayloadAction<string>) => {
            state.refetch = action.payload;
        },
        clearUserQuery: (state,action: PayloadAction<string>) => {
            if(state.users[action.payload]){
                delete state.users[action.payload];
            }
        }
    }
});

export const { setUserQuery, switchAutoQuery, setRefetch ,clearUserQuery } = roiQuerySlice.actions;
export default roiQuerySlice.reducer;